import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPage from 'flarum/forum/components/UserPage';
export default function addFeedIcons() {
  extend(IndexPage.prototype, 'actionItems', function (items) {
    if (!app.forum.attribute('ianm-syndication.plugin.forum-icons')) {
      return;
    }
    if (items.has('refresh')) items.setPriority('refresh', 100);
    if (items.has('markAllAsRead')) items.setPriority('markAllAsRead', 90);
    const format = app.forum.attribute('ianm-syndication.plugin.forum-format');
    let url = app.forum.attribute('baseUrl') + '/' + format;
    const currentTag = 'flarum-tags' in flarum.extensions ? app.currentTag?.() : undefined;
    if (currentTag) {
      url = url + '/t/' + currentTag.slug();
    }
    items.add('rss-feed', m(LinkButton, {
      icon: "fas fa-rss",
      className: "Button Button--icon",
      href: url,
      target: "_blank"
    }), 105);
  });
  extend(DiscussionControls, 'userControls', function (items, discussion) {
    if (!app.forum.attribute('ianm-syndication.plugin.forum-icons')) {
      return;
    }
    const format = app.forum.attribute('ianm-syndication.plugin.forum-format');
    items.add('rss-link', m(LinkButton, {
      icon: "fas fa-rss",
      href: app.forum.attribute('baseUrl') + `/${format}/d/` + discussion.id(),
      external: true,
      target: "_blank"
    }, app.translator.trans('ianm-syndication.forum.discussion.feed_link')));
  });
  extend(UserPage.prototype, 'navItems', function (items) {
    if (!app.forum.attribute('ianm-syndication.plugin.forum-icons') || !this.user) {
      return;
    }
    const format = app.forum.attribute('ianm-syndication.plugin.forum-format');
    const url = app.forum.attribute('baseUrl') + '/' + format + '/u/' + this.user.username() + '/posts';
    items.add('rss-feed', m(LinkButton, {
      icon: "fas fa-rss",
      href: url,
      external: true,
      target: "_blank"
    }, app.translator.trans('ianm-syndication.forum.discussion.feed_link')), 40);
  });
}